import { Page } from '@/core/architecture'

import { ConsolePostCreateTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsolePostCreate Page
 * Implemented as a practical sample.
 */
export const ConsolePostCreate: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsolePostCreateTemplate state={state} {...actions} />
}
